// IMPORTANT: Make sure to use env.property in this file instead of
// process.env.property.

// If adding a new config item which requires the use of process.env
// make sure to add it to the env.js file.
import env from 'env';
import {globalCssExports} from 'utils/commonUtils';

const advertSizes = globalCssExports("adverts");

const topBannerSlotSmall = [
  [300, advertSizes.smallBannerHeight],
  [320, advertSizes.smallBannerHeight]
];

const topBannerSlotMedium = [
  ...topBannerSlotSmall,
  [advertSizes.mediumBannerWidth, advertSizes.mediumBannerHeight]
];

const topBannerSlotLarge = [
  ...topBannerSlotMedium,
  [advertSizes.billboardBannerWidth, advertSizes.billboardBannerHeight]
];

const config = {
  environment: env.NODE_ENV || 'development',
  isProduction: env.NODE_ENV === 'production',
  protectableFeatures: env.PROTECTABLE_FEATURES === "on",

  featureBucket : {
    configExpiry: env.FEATURE_CANARY_CONFIG_EXPIRY || 1800000,
    configUrl: env.FEATURE_CANARY_CONFIG_URL || "https://sportinglife.com/canary/features.json",
    cookie: {
      key: env.FEATURE_BUCKET_COOKIE_KEY || 'bucketID',
      maxAge: env.FEATURE_BUCKET_COOKIE_AGE || 900000
    }
  },

  cookiePolicy: {
    cookieName: "cookie_policy_accepted",
    cookieValue: "yes",
    policyLink: "/privacy"
  },

  splashpage: {
    cookieName: "splash_screen_seen",
    cookieValue: "true"
  },

  wss: {
    topic: {
      hrFastResults: env.HR_FR_TOPIC || "hr/$cg/+/+/+/fast-result"
    }
  },

  app: {
    head: {
      title: "Sporting Life Universal Web Application"
    }
  },

  nav: {
    event: {
      title: env.NAV_EVENT_TITLE,
      uri: env.NAV_EVENT_URL,
      mainNavIndex: env.NAV_EVENT_MAIN_INDEX || 5,
      subNavIndex: env.NAV_EVENT_SUB_INDEX || 7
    }
  },

  pageTitle: {
    mainSuffix: "Sporting Life",
    midfix: {
      football: "Football",
      horseRacing: "Horse Racing",
      myStable: "My Stable",
      greyhoundRacing: "Greyhound Racing",
      cricket: "Cricket",
      darts: "Darts",
      golf: "Golf",
      rugbyLeague: "Rugby League",
      rugbyUnion: "Rugby Union",
      tennis: "Tennis",
      boxing: "Boxing",
      formula1: "Formula 1",
      snooker: "Snooker",
      nfl: "NFL",
      insider: "Insider"
    },
    default: "Horse Racing Tips & Results | Football Scores & News"
  },

  cacheBuster: env.API_GET_CACHE_BUSTER,
  canonicalBase: env.SITE_CANONICAL_BASE || 'https://www.sportinglife.com',
  apiUrl: env.SERVICE_APP_HOSTNAME || 'www.sportinglife.com',
  apiPort: env.SERVICE_APP_PORT || 8080,
  apiProtocol: env.SERVICE_APP_PROTOCOL || 'https',
  apiTimeout: env.SERVICE_APP_TIMEOUT || 30000,
  siteTimeout: env.SERVICE_SITE_TIMEOUT || 30000,
  siteMaxConnections: env.SERVICE_SITE_MAX_CONN,
  siteRestartConnections: env.SERVICE_SITE_RESTART_CONN_COUNT,
  cookieDomain: env.COOKIE_DOMAIN || 'sportinglife.com',
  googleConsoleTag: env.GOOGLE_CONSOLE_TAG || '',
  googleRecaptchaSiteKey: env.GOOGLE_RECAPTCHA_SITE_KEY || '6LeErDAUAAAAACZPNLbjbFpYwP_FqnjVvs-_T3Y2',
  itunesAppId: env.ITUNES_APP_ID || '1077299974',
  fastresultsAppId: env.FASTRESULTS_APP_ID|| '1345907668',
  SkyBetAccountEnabled: env.SBG_ACC_ENABLED != "false",
  skyBetAccountHost: env.SBG_SSO_HOST || "www.skybet.com",
  serviceWorkerEnabled: env.SERVICE_WORKER_ENABLED != "false",
  staging: env.STAGING === "true",
  cacheHost: env.CACHE_HOST,
  applicationColour: env.APPLICATION_COLOUR,
  atrVideo: { placeholderTimestamp: env.ATR_VIDEO_TIMESTAMP || 0 },
  api: {
    football: {
      matchDetail: "api/football/match_detail",
      matchEvents: "api/football/match_events",
      dailyMatches: "api/football/match_day",
      competitions: "api/football/competition",
      teams: "api/football/team",
      loadMatch: "api/football/match",
      loadMatches: "api/football/match",
      loadTeamForm: "api/football/form",
      vidiprinter: "api/football/vidiprinter",
      competitionList: "api/football/competition",
      leagueTable: "api/football/league-tables",
      fixtures: "api/football/match_day"
    },
    horseRacing: {
      mostFollowed: {
        horse: "api/horse-racing/horse/search/most-followed",
        jockey: "api/horse-racing/jockey/search/most-followed",
        trainer: "api/horse-racing/trainer/search/most-followed"
      },
      loadFastCard: "api/horse-racing/fast-card",
      loadFastResult: "api/horse-racing/fast-result",
      loadMeetingData: "api/horse-racing/fast-meeting-result",
      loadEntries : "api/horse-racing/mystableEntry",
      loadResults : "api/horse-racing/mystableResult",
      loadMeeting: "api/horse-racing/meeting",
      loadMeetings: "api/horse-racing/racing/racecards",
      loadRace: "api/horse-racing/race",
      horse: "api/horse-racing/horse",
      jockey: "api/horse-racing/jockey",
      trainer: "api/horse-racing/trainer",
      atrVideo: "api/horse-racing/atr-url",
      nonRunners: "api/horse-racing/nonrunner",
      going: "api/horse-racing/going",
      naps: "api/horse-racing/naps",
      abc: "api/horse-racing/abcguide"
    },
    greyhoundRacing: {
      loadFastResult: "api/greyhound-racing/fast-result",
      loadMeetings: "api/greyhound-racing/meeting",
      loadMeeting: "api/greyhound-racing/meeting",
      loadRace: "api/greyhound-racing/race",
      loadGreyhound: "api/greyhound-racing/greyhound"
    },
    common: {
      wssUrl: "api/wss",
      loadArticle: "api/cms-news/article",
      loadArticleSummary: "api/cms-news/article-summary",
      layout: {
        loadLayout: "api/cms-news/layout"
      },
      userService: {
        unsubscribeEmail: "api/user/email/unsubscribe",
        feedback: "api/user/feedback",
        loadSubscriptions: "api/user/subscription/search",
        saveSubscriptions: "api/user/subscription",
        deleteSubscriptions: "api/user/subscription"
      }
    },
    sso: {
      loggedIn: "logged-in",
      loggedOut: "logged-out"
    },
    media: {
      loadMedia: "api/cms-media/media",
      imagesURL: env.IMAGES_URL || 'https://www.sportinglife.com/images/',
      fallbackSilkPath: "/img/default-silk.png"
    },
    splashpage: {
      cmsSplashpageUri: "api/cms-app/splashpage/"
    },
    campaignGroups: {
      cmsCampaignGroupsUri: "api/cms-app/campaign-groups/current-filtered"
    }
  },
  metricsVendors: {
    signal: {
      name: "SBG Signal",
      setup: {}
    },
    google: {
      name: "Google Analytics",
      setup: {
        trackingId: env.GOOGLE_ANALYTICS_PROPERTY_ID || "UA-83524757-1",
        samplingRate: env.GOOGLE_ANALYTICS_SAMPLING_RATE || "100"
      }
    },
    omniture: {
      name: "Omniture",
      setup: {
        suite: env.OMNITURE_SUITE || "sbgsportinglifetest"
      }
    }
  },
  sitemap: {
    SITEMAP_DAYS_BEHIND: env.SITEMAP_DAYS_BEHIND || 6,
    SITEMAP_DAYS_AHEAD: env.SITEMAP_DAYS_AHEAD || 6,
    SITEMAP_BASKET_ARTICLE_LIMIT: env.SITEMAP_BASKET_ARTICLE_LIMIT || 50
  },
  cacheTimeStatic: isNaN(env.STATIC_ASSET_CACHE_TTL) ? 604800000 : env.STATIC_ASSET_CACHE_TTL,  // One week by default
  cacheTimePage: "1",
  hstsCacheTime: "7776000",
  oddschecker: {
    enabled: env.ODDSCHECKER_ENABLED != "false",
    betlinkEnabled: true,
    affId: env.ODDSCHECKER_AFF_ID || "1197320072",
    apiKey: env.ODDSCHECKER_API_KEY || "22e9d194-d446-4f45-b59a-5b000d4e97dc",
    slotID: {
      footer: "Hkz08doCuf",
      homepage: {
        leaderboard: "Bkx55OuBm",
        mpu: "HkiuixDSm"
      },
      racingFastResults: {
        leaderboard: "B1VD8uzlm"
      },
      racing: {
        leaderboard: "BkM6cu_rQ",
        mpu: "SyiiquOHX"
      },
      football: {
        leaderboard: "r15kj__rm",
        mpu: "Hyw0cudrm"
      },
      greyhounds: {
        leaderboard: "S1dzoOOBm",
        mpu: "r1AljuOrQ"
      },
      golf: {
        leaderboard: "HJAZhJiBm",
        mpu: "Hky-hyjSQ"
      },
      darts: {
        leaderboard: "SyeNnksrQ",
        mpu: "Sk3MhksHQ"
      },
      cricket: {
        leaderboard: "S14wgAzwQ",
        mpu: "B1vrgCGvQ"
      },
      snooker: {
        leaderboard: "B1FKeRzwm",
        mpu: "SyOtg0fwQ"
      },
      tennis: {
        leaderboard: "SkAFgCzP7",
        mpu: "ry6YlRfwX"
      },
      boxing: {
        leaderboard: "ByJqe0zw7",
        mpu: "HJgAKgRGDQ"
      },
      formula1: {
        leaderboard: "BkA--0GPm",
        mpu: "H1l6ZZRGw7"
      },
      nfl: {
        leaderboard: "HkpWZCGP7",
        mpu: "SJsZ-Cfv7"
      },
      "rugby-league": {
        leaderboard: "Sk1o0kiSQ",
        mpu: "r1cKAksH7"
      },
      "rugby-union": {
        leaderboard: "BJ3deejBX",
        mpu: "B1nvxejH7"
      },
      "other-sports": {
        leaderboard: "B1Q5bCzvm",
        mpu: "ryfq-0fPm"
      },
      "custom-basket": {
        leaderboard: "B1Q5bCzvm",
        mpu: "ryfq-0fPm"
      },
      cms: {
        leaderboard: "Syg4E1ED7"
      }
    }
  },
  googlePublisherTag: {
    enabled: env.GPT_ENABLED != "false",
    topBanner: {
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: topBannerSlotSmall
        },
        {
          viewport: [advertSizes.mediumBannerSafeWidth, 0],
          slot: topBannerSlotMedium
        },
        {
          viewport: [advertSizes.billboardBannerSafeWidth, 0],
          slot: topBannerSlotLarge
        }
      ],
      targeting: {
        'Display_Ad_Position': ['ATF'],
        'Display_Ad_Size': ['Top_Banner']
      }
    },
    topMPU: {
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [
            [300, advertSizes.singleMpuHeight],
            [300, advertSizes.doubleMpuHeight]
          ]
        }
      ],
      targeting: {
        'Display_Ad_Position': ['ATF'],
        'Display_Ad_Size': ['Top_MPU']
      }
    },
    bottomMPU: {
      sizeMapping: [
        {viewport: [0, 0], slot: [
          [300, advertSizes.singleMpuHeight],
          [300, advertSizes.doubleMpuHeight]
        ]}
      ],
      targeting: {
        'Display_Ad_Position': ['BTF'],
        'Display_Ad_Size': ['Bottom_MPU']
      }
    },
    singleBottomMPU: {
      sizeMapping: [
        {viewport: [0, 0], slot: [
          [300, advertSizes.singleMpuHeight],
          [300, advertSizes.doubleMpuHeight]
        ]}
      ],
      targeting: {
        'Display_Ad_Position': ['BTF'],
        'Display_Ad_Size': ['Bottom_MPU']
      }
    }
  },
  structuredData: {
    legalName : "Hestview Ltd",
    founded: 1859,
    email: "editorial@sportinglife.com",
    streetAddress: "2 Wellington Place",
    city: "Leeds",
    region: "West Yorkshire",
    postalCode: "LS1 4AP"
  },
  tam: {
    enabled: env.AMAZON_TAM_ENABLED != "false",
    url: "//c.amazon-adsystem.com/aax2/apstag.js",
    scriptLoadTimeoutMs: 200,
    bidRetreivalTimeoutMs: 6000,
    initializationParams: {
      pubID: '3117',
      adServer: 'googletag',
      bidTimeout: 4000
    }
  }
};

export default config;



// WEBPACK FOOTER //
// ./config.js